<header>
  <global-nav [forceShowFeedbackSurveryStatus]="false"  [appLabel]="'APP.TITLE' | translate" [menuData]="menuData$ | async"></global-nav>
  <!-- ContentLibrary's menu -->
  <div class="row page-title">
    <span class="col-md-8 col-sm-8">Content Library</span>
    <div class="d-flex justify-content-end col-md-3 buttonMargin" *ngIf="isActiveTab(tabPriorityName)">
      <dsy-button *ngIf="isTemplatePriorityEditEnabled" size="large" variant="secondary" label="dsy-button" button-style="" type="misc"
        [disabled]="isLoadingActive"
        (click)="templatePriorityService.setAction('CANCEL')" class="me-3">
        Cancel
      </dsy-button>
      <dsy-button *ngIf="isTemplatePriorityEditEnabled" size="large" variant="primary" label="dsy-button" button-size="medium" button-shape="round" button-spacing="regular" button-type="misc"
        [disabled]="isLoadingActive || !templatePrioritySaveIsEnabled"
        (click)="templatePriorityService.setAction('SAVE')">
        Save
        <dsy-loader *ngIf="isLoadingActive" id="spinner4s" type="spinner" size="xx-small"></dsy-loader>
      </dsy-button>
      <dsy-button *ngIf="!isTemplatePriorityEditEnabled" size="large" variant="primary" label="dsy-button" button-style="" type="misc"
        [disabled]="isLoadingActive || opps?.length === 0"
        (click)="templatePriorityService.setAction('EDIT')">
        Edit
      </dsy-button>
      <dsy-button *ngIf="opps?.length > 0" button-color="default" button-variant="secondary" button-size="medium" button-shape="round" button-spacing="regular" button-type="misc"
        [disabled]="isExportButtonDisabled"
        (click)="exportService.setOpenExportModal(true)">
        Export
        <dsy-loader *ngIf="templatePriorityExportLoadingActive" id="spinner4s" type="spinner" size="xx-small"></dsy-loader>
      </dsy-button>
    </div>
  </div>
  <nav class="nav nav-tabs">
    <!-- Current active route title -->
    <div class="row">
      <ul class="nav link-title">
        <li class="nav-item">
          <a *ngIf="!isLoadingActive" class="nav-link" [ngClass]="isActiveTab(tabDefinitionName) ? 'active active-tab' : ''" [routerLink]="['template-definition']">Template Definitions</a>
          <a *ngIf="isLoadingActive" class="nav-link" [ngClass]="isActiveTab(tabDefinitionName) ? 'active active-tab' : ''">Template Definitions</a>
        </li>
        <li class="nav-item">
          <a *ngIf="!isLoadingActive" class="nav-link" [ngClass]="isActiveTab(tabBulkEditName) ? 'active active-tab' : ''" [routerLink]="['template-bulk-edit']">Template Bulk Edit</a>
          <a *ngIf="isLoadingActive" class="nav-link" [ngClass]="isActiveTab(tabBulkEditName) ? 'active active-tab' : ''">Template Bulk Edit</a>
        </li>
        <li class="nav-item">
          <a *ngIf="!isLoadingActive" class="nav-link" [ngClass]="isActiveTab(tabPriorityName) ? 'active active-tab' : ''" [routerLink]="['template-priority']">Template Priority</a>
          <a *ngIf="isLoadingActive" class="nav-link" [ngClass]="isActiveTab(tabPriorityName) ? 'active active-tab' : ''">Template Priority</a>
        </li>

        <!-- <li class="nav-item">
          <a class="nav-link" [ngClass]="isActiveTab(tabDefinitionName) ? 'active active-tab' : ''" [routerLink]="['template-definition']">Template Definitions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="isActiveTab(tabBulkEditName) ? 'active active-tab' : ''" [routerLink]="['template-bulk-edit']">Template Bulk Edit</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="isActiveTab(tabPriorityName) ? 'active active-tab' : ''" [routerLink]="['template-priority']">Template Priority</a>
        </li> -->
      </ul>
    </div>
  </nav>
</header>
<div class="content container-fluid contPadding" [ngClass]="isActiveTab(tabPriorityName) ? 'background-grey' : ''">
  <!-- Confirm Credentials Modal -->
  <div class="modal fade" bsModal #checkCredentialsModal="bs-modal" [config]="{backdrop: 'static'}"
       tabindex="-1" role="dialog" aria-labelledby="checkCredentialsModalLabel">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="checkCredentialsModalLabel">Checking authorization</h4>
        </div>
        <div class="modal-body">
          <div [innerHTML]="checkCredentialsModalHTMLContent | safeHTML"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- Confirm Credentials Modal -->
  <section>
    <router-outlet (activate)="getDataFromComponent($event)"></router-outlet>
  </section>
</div>
<footer>
  <global-footer></global-footer>
</footer>
